<template>
	<div>
		<div v-if="showModal">
			<teleport to="#fiche-modal">
				<div class="modal-mask modal">
					<div class="modal-wrapper" @click="closeModal">
						<div class="modal-dialog modal-lg">
							<div class="modal-content" @click.stop>
								<div class="modal-header">
									<div class="col-lg-12 dynvibeTitleBox" style="padding-bottom: 10px; margin-bottom: 0px">
										<h5 class="modal-title" id="dynvibeGraphDetailsTitleAuthors">
											{{ keyword }}
											<span v-if="level">({{ level }})</span>
											- {{ date.gte }} to {{ date.lte }}
											<span v-if="country">
												-
												{{ country.toUpperCase() }}</span
											>
											<button type="button" class="close" @click="closeModal">
												<span aria-hidden="true">
													<i class="icon-x"></i>
												</span>
											</button>
										</h5>
									</div>
								</div>
								<div class="modal-body" id="modal-edit-body">
									<explorecounts ref="explorecounts" v-bind="$props"></explorecounts>
									<div class="row dynvibeRow">
										<div class="col-lg-12">
											<div class="dynvibeBox">
												<div class="col-lg-12 dynvibeTitleBox">
													<h2>Volume Evolution</h2>
												</div>
												<div class="col-lg-12" style="padding-top: 5px">
													<label class="labelRadio"
														>Daily
														<input
															type="radio"
															name="grouping"
															value="day"
															v-model="graphrange"
															:checked="graphrange === 'day'"
														/>
														<span class="checkmark"></span>
													</label>
													<label class="labelRadio"
														>Weekly
														<input
															type="radio"
															name="grouping"
															value="week"
															v-model="graphrange"
															:checked="graphrange === 'week'"
														/>
														<span class="checkmark"></span>
													</label>
													<label class="labelRadio"
														>Monthly
														<input
															type="radio"
															name="grouping"
															value="month"
															v-model="graphrange"
															:checked="graphrange === 'month'"
														/>
														<span class="checkmark"></span>
													</label>
													<dynvibestock
														:explorePage="true"
														:constructorType="'stockChart'"
														ref="stock"
														axios="storiesTopicLine"
														:type="'stockChart'"
														:typo="'search'"
														:legend="true"
														:value="keyword + ' Trend Line'"
														:trendfilters="filters"
														:mainkeywordmixin="keyword"
														:levelmixin="level"
														:datemixin="date"
														:countrymixin="country"
														@zoomchart="changeZoomChart"
													></dynvibestock>
												</div>
											</div>
										</div>
									</div>

									<div class="row dynvibeRow">
										<div class="col-lg-12">
											<div class="dynvibeBox" style="min-height: 200px">
												<div class="col-lg-12 dynvibeTitleBox">
													<h2>Key metrics</h2>
												</div>
												<exploremodalmetrics
													ref="metrics"
													:level="level"
													:filters="filters"
													:explorePage="true"
													:keyword="keyword"
													:date="date"
													:country="country"
												></exploremodalmetrics>
											</div>
										</div>
									</div>
									<div class="row dynvibeRow">
										<div class="col-lg-12">
											<div class="dynvibeBox">
												<div class="col-lg-12">
													<div class="col-lg-12 dynvibeTitleBox">
														<h2>Dynamics</h2>
													</div>
												</div>
												<div class="col-lg-12">
													<dynvibedynamiccategories
														:explorePage="true"
														ref="categoriesdynamic"
														axios="categoriesdynamic"
														:filters="tempFilters"
														:mainkeywordmixin="keyword"
														:levelmixin="level"
														:datemixin="date"
														:countrymixin="country"
														xTitle="Dynamic"
														yTitle="Volume"
													></dynvibedynamiccategories>
												</div>
											</div>
										</div>
									</div>
									<div class="row dynvibeRow" id="postsBox">
										<incomingposts
											ref="incomingposts"
											:trendfilters="filters"
											:mainkeyword="keyword"
											:date="date"
											:country="country"
											:level="level"
											:explorePage="true"
											@expandposts="expandPosts($event)"
										></incomingposts>
									</div>

									<div class="row dynvibeRow">
										<div class="col-lg-6">
											<dynvibewordcloud
												ref="keywordWordcloud"
												title="Top keywords"
												axios="wordcloudKeywords"
												:editable="true"
												:level="level"
												:explorePage="true"
												:mainkeyword="keyword"
												:date="date"
												:country="country"
												:clickable="false"
											></dynvibewordcloud>
										</div>
										<div class="col-lg-6">
											<dynvibewordcloud
												ref="hashtagWordcloud"
												title="Top hashtags"
												axios="wordcloudHashtags"
												:mainkeyword="keyword"
												:date="date"
												:country="country"
												:editable="true"
												:level="level"
												:explorePage="true"
												:clickable="false"
											></dynvibewordcloud>
										</div>
									</div>

									<div class="row dynvibeRow">
										<div class="col-lg-12">
											<div class="dynvibeBox" style="min-height: 350px">
												<div class="col-lg-12 dynvibeTitleBox">
													<h2>Associated mastertags</h2>
												</div>

												<ul class="tabs-columns">
													<li
														v-bind:class="{ active: selectedTab === 'mostAssociatedBrands' }"
														@click="selectedTab = 'mostAssociatedBrands'"
													>
														<a href="#"> Brands</a>
													</li>
													<li
														v-bind:class="{ active: selectedTab === 'mostAssociatedTrends' }"
														@click="selectedTab = 'mostAssociatedTrends'"
													>
														<a href="#">Trends</a>
													</li>
													<li
														v-bind:class="{ active: selectedTab === 'mostAssociatedTopics' }"
														@click="selectedTab = 'mostAssociatedTopics'"
													>
														<a href="#">Topics</a>
													</li>
												</ul>
												<div style="float: left; padding-left: 20px; padding-top: 8px">
													<label class="labelCheckbox">
														Show evolution
														<input
															type="checkbox"
															name="displayHighchartsTrend"
															v-model="displayHighchartsTrend"
														/>
														<span class="checkboxmark"></span>
													</label>
												</div>
												<div class="tabs-content">
													<dynvibecolumn
														:class="'tab-pane ' + (tab == 'Brands' ? 'active' : '')"
														ref="mostAssociated"
														:explorePage="true"
														:axios="selectedTab"
														:clickable="false"
														:legend="true"
														:title="selectedTab"
														:mainkeywordmixin="keyword"
														:levelmixin="level"
														:datemixin="date"
														:countrymixin="country"
														:displayGrowth="displayHighchartsTrend"
													></dynvibecolumn>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</teleport>
		</div>
	</div>
</template>

<script>
import exploremodalmetrics from "@/components/explore/ExploreModalMetrics.vue";
import dynvibewordcloud from "@/components/vueCharts/DynvibeWordCloud.vue";
import dynvibecolumn from "@/components/vueCharts/DynvibeColumn.vue";
import dynvibestock from "@/components/vueCharts/DynvibeStock.vue";
import incomingposts from "@/components/incoming/IncomingPosts.vue";
import explorecounts from "@/components/explore/ExploreModalCounts.vue";
import dynvibedynamiccategories from "@/components/vueCharts/DynvibeBubble.vue";

function flushQueue() {
	return new Promise((resolve) => setTimeout(resolve, 0));
}

export default {
	name: "ExploreModal",
	//mixins: [graphMixin],
	props: {
		filters: {
			type: Object,
			default: function () {
				return {};
			},
		},
		keyword: {
			type: String,
			default: "",
		},
		level: {
			type: String,
			default: "",
		},
		date: {
			type: Object,
			default: function () {
				return {
					gte: "",
					lte: "",
				};
			},
		},
		country: {
			type: String,
			default: "",
		},
	},
	components: {
		exploremodalmetrics: exploremodalmetrics,
		dynvibewordcloud: dynvibewordcloud,
		dynvibecolumn: dynvibecolumn,
		dynvibestock: dynvibestock,
		incomingposts: incomingposts,
		explorecounts: explorecounts,
		dynvibedynamiccategories: dynvibedynamiccategories,
	},
	emits: ["closed"],
	data() {
		return {
			showModal: false,
			graphrange: "day",
			zoomChart: 1,
			displayHighchartsTrend: true,
			tab: "Brands",
			selectedTab: "mostAssociatedBrands", // name of selected tab for  brands/trends/topics tabs
			tempFilters: {}, // for categoriesDynamix to work filters awaited are not conform to props stucture s
		};
	},
	methods: {
		async reflow(ref) {
			await flushQueue();
			this.$refs[ref].$refs.basechart.reflow();
		},
		closeModal() {
			this.showModal = false;
			this.graphrange = "day";
			this.selectedTab = "mostAssociatedBrands";

			this.$emit("closed");
		},
		expandPosts(e) {
			this.postsExpanded = e;
			//let $this = this;
			/*setTimeout(function () {
				$this.$refs.wordcloudKeywords.updateWordcloud();
			}, 250);*/
		},
		getFiltersDynamic() {
			this.tempFilters = { ...this.filters };
			if (this.level == "categories") {
				this.tempFilters.category = this.keyword;
			} else if (this.level == "subcategories") {
				this.tempFilters.subcategory = this.keyword;
			} else if (this.level == "mastertag") {
				this.tempFilters.mastertag = this.keyword;
			}
		},

		/*resetFilters() {
			this.refreshComponents();
		},*/
		/*refreshComponents(columnGraphs = true, wordcloud = true, posts = true) {
			//let parameters = { ...this.trendfilters, ...this.semanticfilters };
			//parameters["modalkeywords"] = JSON.stringify(this.breadcrumb);
		},*/

		changeZoomChart(zoomChart) {
			this.zoomChart = zoomChart;
		},
	},
	watch: {
		keyword(newVal) {
			if (newVal !== "") {
				this.showModal = true;
			} else {
				this.showModal = false;
			}
			this.getFiltersDynamic();
		},
		graphrange(newVal) {
			//this.$refs.stock.$refs.basechart.reflow();
			let chartOptions = this.$refs.stock.$refs.basechart.getChartOptions();
			if (chartOptions.series) {
				chartOptions.series[0].dataGrouping.units = [[newVal, [1]]];
				chartOptions.series[1].dataGrouping.units = [[newVal, [1]]];
			}

			this.$refs.stock.changeZoom(this.zoomChart);
		},
		showModal() {},
	},
};
</script>

<style scoped>
.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.close {
	outline: 0;
}

.dynvibeButtonIcon {
	margin-left: 0;
}

@-moz-keyframes spin {
	100% {
		-moz-transform: rotate(360deg);
	}
}

@-webkit-keyframes spin {
	100% {
		-webkit-transform: rotate(360deg);
	}
}

@keyframes spin {
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}

#wordcloudBox,
#postsBox {
	margin-left: 0px;
}

#resetfilters {
	float: right;
	color: red;
	border: 1px solid red;
	background-color: transparent;
	margin-top: 5px;
}

.modal-body {
	padding-bottom: 100px;
}

.modal-footer {
	position: absolute;
	bottom: 0;
	width: 100%;
	background-color: #fff;
}

ol.breadcrumb li {
	color: #33d1cd;
}

ol.breadcrumb li.active {
	color: #ccc;
}

ol.breadcrumb li > span {
	color: #ccc;
}

.labelRadio {
	display: inline;
	position: relative;
	padding-left: 25px;
	margin-right: 10px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	color: #8e8e8e;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.labelRadio input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

/* Create a custom checkbox */
.checkmark {
	position: absolute;
	top: 0;
	left: 0;
	height: 15px;
	width: 15px;
	background-color: #fff;
	border-radius: 50%;
	border: 1px solid #33d1cd;
}

/* On mouse-over, add a grey background color */
.labelRadio:hover input ~ .checkmark {
	background-color: rgba(51, 209, 205, 0.2);
}

/* When the checkbox is checked, add a blue background */
.labelRadio input:checked ~ .checkmark {
	background-color: #33d1cd;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

/* Show the checkmark when checked */
.labelRadio input:checked ~ .checkmark:after {
	display: block;
}

.labelCheckbox {
	display: inline;
	position: relative;
	padding-left: 25px;
	margin-right: 10px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	color: #8e8e8e;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.labelCheckbox input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

/* Create a custom checkbox */
.checkboxmark {
	position: absolute;
	top: 0;
	left: 0;
	height: 15px;
	width: 15px;
	background-color: #eee;
}

.labelCheckbox:hover input ~ .checkboxmark {
	background-color: #eee;
}

.checkboxmark:after {
	content: "\e923";
	position: absolute;
	display: none;
}

.labelCheckbox input:checked ~ .checkboxmark:after {
	display: block;
}

.checkboxmark:after {
	content: "\e923";
	position: absolute;
	top: -2px;
	font-family: i;
	font-size: 11px;
	line-height: 20px;
}

.tabs-columns {
	border-bottom: none;
	list-style: none;
	padding-left: 0;
	margin-bottom: 60px;
}

.tabs-columns > li {
	position: relative;
	display: block;
	float: left;
	padding-top: 10px;
	padding-right: 15px;
	padding-bottom: 10px;
	padding-left: 15px;
	background-color: transparent;
	font-size: 16px;
	font-weight: 700;
	color: #cacaca;
	text-transform: uppercase;
}

.tabs-columns > li.active > a {
	color: #757575;
}

.tabs-columns > li:first-child a:before {
	content: "";
	display: block;
	position: absolute;
	left: 15px;
	bottom: 0;
	width: 20px;
	height: 4px;
	background-color: #757575;
	z-index: 0;
}

.tabs-content {
	margin-left: -25px;
	margin-right: -25px;
}

.icon-arrow {
	margin-left: 5px;
}
</style>
